'use client'
import React, { useEffect, useState, useRef } from 'react'
import styles from './styles.module.scss'

import { If } from '@/components'
import useMediaQuery from '@/utils/browser/getDeviceScreen'
import FullCountdown from './components/FullLayout'
import SimpleCountdown from './components/SimpleLayout'

const TopbarFixed = ({
  text = 'A oferta termina em:',
  hasTimer = true,
  openModal,
  hasCta = true,
  simple = false,
  hasHour = false,
  hasPercent = true,
  percent = 70,
  bottomText = '',
  isLive = true,
  buttonColor,
  prefixPercent,
  buttonTextColor,
  variant
}) => {
  const isMobile = useMediaQuery('mobile')
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 })
  const [isFixed, setIsFixed] = useState(false)
  const topbarRef = useRef(null)
  const [isHidden, setIsHidden] = useState(false)

  useEffect(() => {
    const topbarHeight = topbarRef.current?.offsetHeight || 0

    const handleScroll = () => {
      if (window.scrollY > topbarHeight) {
        setIsFixed(true)
        setIsHidden(false)
      } else {
        setIsHidden(false)
        setIsFixed(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    const now = new Date()
    let countdownEnd

    const savedTime = sessionStorage.getItem('countdownEnd')
    if (savedTime) {
      countdownEnd = new Date(savedTime)
    } else {
      countdownEnd = simple
        ? new Date(now.getTime() + 15 * 60 * 1000)
        : new Date(now.setHours(23, 59, 59, 999))

      sessionStorage.setItem('countdownEnd', countdownEnd.toISOString())
    }

    const updateCountdown = () => {
      const now = new Date()
      const timeDifference = countdownEnd - now

      if (timeDifference <= 0) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
        clearInterval(intervalId)
        sessionStorage.removeItem('countdownEnd')
        return
      }

      const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24)
      const minutes = Math.floor((timeDifference / (1000 * 60)) % 60)
      const seconds = Math.floor((timeDifference / 1000) % 60)

      setTimeLeft({ hours, minutes, seconds })
    }

    const intervalId = setInterval(updateCountdown, 1000)
    updateCountdown()

    return () => clearInterval(intervalId)
  }, [simple])

  return (
    <div
      ref={topbarRef}
      className={`${styles.topbar} ${isFixed ? styles.topbarFixed : ''} ${isHidden ? styles.hidden : ''} ${simple && styles.simpleLayout}`}
    >
      <div className={`${styles.container} `}>
        <If
          condition={simple}
          renderIf={
            <SimpleCountdown
              text={!isMobile ? text : 'A oferta termina em:'}
              hasHour={hasHour}
              timeLeft={timeLeft}
            />
          }
          renderElse={
            <FullCountdown
              text={!isMobile ? text : 'A oferta termina em:'}
              hasHour={hasHour}
              isMobile={isMobile}
              timeLeft={timeLeft}
              percent={percent}
              hasCta={hasCta}
              openModal={openModal}
              isLive={isLive}
              variant={variant}
              hasPercent={hasPercent}
              buttonTextColor={buttonTextColor}
              hasTimer={hasTimer}
              bottomText={bottomText}
              buttonColor={buttonColor}
              prefixPercent={prefixPercent}
            />
          }
        />
      </div>
    </div>
  )
}

export default TopbarFixed
